import React from 'react'
import {Col, Form, Input, Row} from 'antd'
import {compose} from 'recompose'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import {VehiclesApi} from '../../../../api/Projects/Resources'
import withData from '../../../../elements/Select/withData'
import {get} from 'lodash'
import {ClientBudgetsApi} from '../../../../api/Corporates/Projects'
import {strVal} from '../../../../modules/Utils'

const {TextArea} = Input

function InServiceForm(props) {
  const {getFieldDecorator} = props.form
  const formItemLayout = {
    labelCol: {
      xs: {span: 24},
      sm: {span: 6},
    },
    wrapperCol: {
      xs: {span: 24},
      sm: {span: 14, offset: 1},
    },
  }
  const {booking, project} = props
  const {list: vehicles, fetching: fetchingVehicles} = useFetchList(() =>
    VehiclesApi.list(project._id),
  )
  const VehiclesSelect = compose(
    withSpinning,
    withData({
      data: vehicles,
    }),
  )(CustomSelect)
  const {
    list: clientBudgetLines,
    fetching: fetchingClientBudgets,
  } = useFetchList(() =>
    ClientBudgetsApi.list(project._key, strVal(booking, 'order.reference.no')),
  )
  const ClientBudgetSelect = compose(
    withSpinning,
    withData({
      data: clientBudgetLines,
    }),
  )(CustomSelect)

  function onChangeVehicle(vehicleID) {
    props.form.resetFields([
      'booking.vehicle.plate',
      'booking.vehicle.driver',
      'booking.vehicle.driverPhone',
      'booking.vehicle.fuelTag',
    ])
    if (vehicleID) {
      const vehicle = vehicles.find(d => d._id === vehicleID)
      props.form.setFieldsValue({
        'booking.vehicle.plate': get(vehicle, 'plate'),
        'booking.vehicle.driver.driverName': get(vehicle, 'driver.driverName'),
        'booking.vehicle.driver.driverPhone': get(
          vehicle,
          'driver.driverPhone',
        ),
        'booking.vehicle.fuelToken.register': get(
          vehicle,
          'fuelToken.register',
        ),
      })
    }
  }

  return (
    <Form>
      <Row>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Line Name'}>
              {getFieldDecorator('name', {
                initialValue: get(booking, 'name'),
              })(<Input placeholder={'Line Name'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              {...{
                labelCol: {
                  sm: {span: 3},
                },
                wrapperCol: {
                  sm: {span: 21},
                },
              }}
              label={'Description'}>
              {getFieldDecorator('description', {
                initialValue: get(booking, 'description'),
              })(<TextArea placeholder={'Description'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Vehicle'}>
            {getFieldDecorator('booking.vehicle._id', {
              initialValue: get(booking, 'booking.vehicle._id'),
            })(
              <VehiclesSelect
                onChange={onChangeVehicle}
                loading={fetchingVehicles}
                keyAtr={'_id'}
                valueAtr={'details'}
                placeholder={'Vehicles'}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Plate No'}>
            {getFieldDecorator('booking.vehicle.plate', {
              initialValue: get(booking, 'booking.vehicle.plate'),
            })(<Input disabled={true} placeholder={'Plate No'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Driver Name'}>
            {getFieldDecorator('booking.vehicle.driver.driverName', {
              initialValue: get(booking, 'booking.vehicle.driver.driverName'),
            })(<Input disabled={true} placeholder={'Driver Name'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Driver Phone'}>
            {getFieldDecorator('booking.vehicle.driver.driverPhone', {
              initialValue: get(booking, 'booking.vehicle.driver.driverPhone'),
            })(<Input disabled={true} placeholder={'Driver Phone'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Fuel Tag'}>
            {getFieldDecorator('booking.vehicle.fuelToken.register', {
              initialValue: get(booking, 'booking.vehicle.fuelToken.register'),
            })(<Input disabled={true} placeholder={'Fuel Tag'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Client Budget Line'}>
            {getFieldDecorator('clientBudget._id', {
              initialValue: get(booking, 'clientBudget._id'),
            })(
              <ClientBudgetSelect
                loading={fetchingClientBudgets}
                keyAtr={'_id'}
                valueAtr={'name'}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

InServiceForm.propTypes = {}
InServiceForm.defaultProps = {}

export default Form.create()((InServiceForm))
